import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTvod = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.06 1.4a.68.68 0 0 0-.48.2.7.7 0 0 0-.2.5v3.5h19.25V2.1a.7.7 0 0 0-.2-.5.68.68 0 0 0-.5-.2H2.07ZM.6.62C1 .22 1.52 0 2.06 0h17.88c.54 0 1.07.22 1.46.62.38.39.6.92.6 1.48v4.2c0 .39-.3.7-.69.7H.7A.7.7 0 0 1 0 6.3V2.1C0 1.54.22 1 .6.62ZM.69 8.4a.7.7 0 0 1 .69.7v9.8c0 .19.07.36.2.5.13.13.3.2.48.2H11a.7.7 0 0 1 .69.7c0 .39-.31.7-.69.7H2.06C1.52 21 1 20.78.6 20.38.22 20 0 19.46 0 18.9V9.1c0-.39.3-.7.69-.7ZM21.31 8.4a.7.7 0 0 1 .69.7v2.1c0 .39-.3.7-.69.7a.7.7 0 0 1-.68-.7V9.1c0-.39.3-.7.68-.7Z",
		fill: "#fff"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.73.02c.37.1.6.47.5.85l-1.38 5.6c-.09.37-.46.6-.83.5a.7.7 0 0 1-.5-.84L6.9.53c.09-.37.46-.6.83-.5ZM15.98.02c.37.1.6.47.5.85l-1.38 5.6c-.09.37-.46.6-.83.5a.7.7 0 0 1-.5-.84l1.38-5.6c.09-.37.46-.6.83-.5ZM14.76 12.19a1.52 1.52 0 0 1 1.5.02l6.01 3.54A1.48 1.48 0 0 1 23 17a1.44 1.44 0 0 1-.73 1.26l-6 3.53a1.52 1.52 0 0 1-2.07-.52c-.13-.22-.2-.47-.2-.73v-7.08a1.44 1.44 0 0 1 .76-1.27ZM21.5 17l-6.02-3.54v7.08L21.51 17Z",
		fill: "currentColor"
	})]
});
export { SvgTvod as ReactComponent };
